import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import { makeServiceBuilder } from '@/common/use-http'
import { checkStatus } from '@/business/http/utils'
import * as urlBuilder from './urls'
import { getChannel } from '../../offers/store'
import { CompleteTransactionResponseDTO } from '../../http/dto/CompleteTransactionResponseDTO' // eslint-disable-line

/**
 * complete a transaction
 * @param {HttpClient} http
 * @param {Object} payload { cardToken: String, cpf: String, msisdn: String, productId: String }
 * @returns {Promise<CompleteTransactionResponseDTO>}
 */
const completeTransaction = async (http, payload) => {
  const canal = await getChannel()
  const response = await http.post(
    urlBuilder.TRANSACTION_CONFIRM(payload.cpf, payload.msisdn),
    {
      ...payload,
      cpf: onlyNumbers(payload.cpf),
      msisdn: onlyNumbers(payload.msisdn)
    },
    false,
    { channel: canal }
  )
  return JSON.parse(response)
}

/**
 * verify a transaction
 * @param {HttpClient} http
 * @param {String} transactionId
 */
const verifyTransaction = (http, transactionId) => {
  return http.requestRaw(
    urlBuilder.TRANSACTION_VERIFY(transactionId),
    {
      method: 'GET'
    }
  )
    .then(checkStatus)
    .then(async response => {
      if (response.status === 204) {
        return {
          done: false
        }
      }

      return {
        done: true,
        ...await response.json()
      }
    })
}

const actions = {
  completeTransaction,
  verifyTransaction
}

const serviceBuilder = makeServiceBuilder(actions)

export { completeTransaction, verifyTransaction, serviceBuilder }
